/**
 * Recebe um array de objetos que contenham as propriedades "link" e "subItems".
 * A função percorre o array e extrai todas as URLs presentes em "link" e seus
 * sub-itens, e retorna um array com todas as URLs encontradas.
 * @param {object[]} itens - Array de objetos que contenham as propriedades "link" e "subItems".
 * @returns {string[]} - Array com todas as URLs encontradas.
 */
export function extrairTodosOsLinks(itens) {
  return itens.flatMap(item => {
    if (item.link) {
      const link = item.link.replace(/\/:[^/]+/g, '');
      return [link];
    }
    if (Array.isArray(item.subItems)) {
      return extrairTodosOsLinks(item.subItems);
    }
    return [];
  });
}

/**
 * Função que gera as permissões por cargo do usuário e retorna objeto com as seguintes propriedades:
 * - `permissoesPorCargo`: objeto com as permissões de cada cargo do usuário. A chave do objeto é o ID do cargo e o valor é o array de rotas permitidas.
 * - `linksPermitidos`: array com todas as rotas permitidas para o usuário.
 * @param {object} store - Instância do Vuex store.
 * @returns {object} - Objeto com permissões por cargo e rotas permitidas.
 */
export function gerarPermissoesPorCargo(store) {
  // Lista de rotas públicas (movida para o topo para evitar referência antecipada)
  const rotasPublicas = [
    { link: '/' },
    { link: '/lgpd' },
    { link: '/login' },
    { link: '/loginErp' },
    { link: '/contrate' },
    { link: '/termo/lgpd' },
    { link: '/assembleia/:id' },
    { link: '/redefinicaoSenha' },
    { link: '/reenvioEmail' },
    { link: '/termo/assembleia' },
    { link: '/cadastrocandidato' },
    { link: '/cadastrocandidatonovo' },
    { link: '/redefinicaosenha/:id' },
    { link: '/assinaturaEletronica' },
  ];

  // Se o usuário não está logado, retorna apenas rotas públicas
  if (!store.state.me || !store.state.me.tp_Pessoa) {
    return {
      permissoesPorCargo: {},
      linksPermitidos: extrairTodosOsLinks(rotasPublicas)
    };
  }

  // Se chegou aqui, o usuário está logado
  const cargosUser = store.state.me.tp_Pessoa.sq_cargo || [];
  const cargoIds = Array.isArray(cargosUser) ? cargosUser : [cargosUser];

  // Obtém o menu de rotas da store (ou array vazio se não existir)
  const menu = Array.isArray(store.state.menuItemsRotas) ? [...store.state.menuItemsRotas] : [];

  // Adiciona rotas públicas ao menu (evitando duplicatas)
  rotasPublicas.forEach(rota => {
    if (!menu.some(item => item.link === rota.link)) {
      menu.push(rota);
    }
  });

  // Se o menu estiver vazio (não carregado), retorna apenas rotas públicas
  if (menu.length === 0) {
    console.warn("Menu vazio ou não carregado corretamente.");
    return {
      permissoesPorCargo: {},
      linksPermitidos: extrairTodosOsLinks(rotasPublicas)
    };
  }

  // Gera permissões por cargo
  const permissoesPorCargo = {};
  cargoIds.forEach(id => {
    permissoesPorCargo[id] = menu;
  });

  return {
    permissoesPorCargo,
    linksPermitidos: extrairTodosOsLinks(menu)
  };
}
